import {Pipe, PipeTransform} from '@angular/core';
import * as removeAccents from 'remove-accents';

@Pipe({
    name: 'searchFilterColaborador'
})
export class SearchFilterColaboradorPipe implements PipeTransform {

    transform(value: any, word: string): any {
        let resultadoPesquisa = [];
        if (!word) {
            return value;
        } else {
            word = removeAccents(word).toLocaleLowerCase();
            resultadoPesquisa = value.filter(s => {
                return (
                    s.colaboradorId.toLocaleString().toLocaleLowerCase().includes(word) ||
                    removeAccents(s.nome).toLocaleString().toLocaleLowerCase().includes(word) ||
                    removeAccents(s.documento).toLocaleString().toLocaleLowerCase().includes(word) ||
                    removeAccents(s.matricula).toLocaleString().toLocaleLowerCase().includes(word) ||
                    removeAccents(s.nomeCentroCusto).toLocaleString().toLocaleLowerCase().includes(word) ||
                    removeAccents(s.nomeUnidade).toLocaleString().toLocaleLowerCase().includes(word) ||
                    removeAccents(s.nomeDepartamento).toLocaleString().toLocaleLowerCase().includes(word) ||
                    removeAccents(s.statusApp).toLocaleString().toLocaleLowerCase().includes(word)
                );
            });
        }
        return resultadoPesquisa;
    }
}
